export const COMPLTE_QC_CHECK_TEXT = `To complete Quality Check, all questionnaire sections must be marked as both SME and QC Complete and all uploaded Submission Documents marked as QC Complete.`;

export const ARE_YOU_SURE_DRAFT =
  'Are you sure you want to submit for Review? The submission will be in Quality Check and you will not be able to make changes to your submission until a WCG staff member makes a request.';
export const ARE_YOU_SURE_QC =
  'Are you sure you want to complete Quality Check? The submission will be in Review and you will not be able to make anymore changes or receive responses.';

export const IRB_DESCRIPTION =
  'IRB+ provides a premium service for your study with personalized oversight and accelerated processing time. Turning on the IRB+ will affect all submissions and sites within the study.';

export const ORGANIZATION_BANNER_TEXT =
  'The following organizations have not been assigned. You can Assign & Complete now or Skip & Complete.';

export const ORGANIZATION_NOTE_TEXT =
  'Note: You can submit for review without assigning all Organizations. Organizations can be assigned later.';
